import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getReturnItems(returnId) {
        return Axios.get(`${baseURL}billing/returnItems/${returnId}`).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    removeReturnItem(itemId) {
        return Axios.delete(
            `${process.env.BARRAMUNDI}billing/returnItem/${itemId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    }
};
